<template>
    <div class="comment"
        :class="{
            'is-authored': isAuthored,
            'is-grouped': isGrouped,
        }">
        <p class="posted-at tags has-addons"
          :class="{
            'is-deleting': isRemoving,
          }">
            <span class="tag is-rounded">
                <template v-if="isRemoving">
                  Действительно удалить?
                </template>
                <template v-else>
                  {{ postedAt }}
                </template>
            </span>
            <!-- <span
                v-if="canRemove"
                class="tag is-rounded is-delete"
                @click="remove">
            </span> -->
        </p>

        <div class="post">
            <div class="level header">
                <div class="level-left">
                    <div class="level-item">
                        <a :href="value.user.url" target="_blank">
                            <span class="author tags has-addons">
                                <span class="tag is-rounded">
                                    <span>{{ value.user.short_name }}</span>
                                </span>
                            </span>
                        </a>
                    </div>
                    <div class="level-item action-button" v-if="canBan">
                        <div
                            v-if="value.user.comments_banned"
                            @click="unban"
                            class="tag is-rounded is-success">
                            <span>Разблокировать</span>
                        </div>
                        <div
                            v-else
                            @click="ban"
                            class="tag is-rounded is-danger">
                            <span>Заблокировать</span>
                        </div>
                    </div>
                </div>
                <div class="separator level-item">
                    <hr>
                </div>
                <div class="level-right">
                    <div class="level-item">
                        <div class="tag is-rounded">
                            <span>{{ this.postedAtExact }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="columns is-mobile">
                <div class="content column">
                    <p v-html="parsedContent"></p>
                </div>
                <div class="remove column is-narrow">
                    <button
                        v-if="canRemove"
                        @click="remove"
                        class="button is-danger is-outlined is-small">
                        <i class="mdi mdi-close mdi-24px"></i>
                    </button>
                </div>
            </div>
        </div>

        <attachments
            v-if="value.attachment_count > 0"
            ref="attachments"
            @change="onAttachmentsChange"
            :storage-indicator="false"
            :show-author="false"
            :show-header="false"
            :can-manage="canManage"
            upload-position="is-top"
            :model="{
                id: value.id,
                type: 'comment'
            }"
        />
    </div>
</template>

<script>
import anchorme from "anchorme";
import sanitizeHtml from "sanitize-html";
import getYouTubeID from "get-youtube-id";

import Attachments from "../Attachments";

import toasts from "../mixins/toasts";

export default Vue.extend({
  props: {
    value: {
      type: Object
    },
    author: {
      type: Object
    },
    isGrouped: {
      type: Boolean
    },
    isMultiple: {
      type: Boolean
    }
  },
  components: {
    Attachments
  },
  mixins: [toasts],
  data() {
    return {
      isRemoving: false,
      postedAt: null
    };
  },
  computed: {
    postedAtExact() {
      return this.$moment(this.value.posted_at)
        .local()
        .format("DD.MM.YYYY HH:mm");
    },
    canRemove() {
      return _.get(this.value, "permissions.remove", false);
    },
    canManage() {
      return _.get(this.value, "permissions.manage", false);
    },
    canBan() {
      return _.get(this.value, "permissions.ban", false);
    },
    parsedContent() {
      if (_.isEmpty(this.value.content)) {
        return "";
      }

      let sanitized = sanitizeHtml(this.value.content, {
        allowedTags: ["b", "i", "u"]
      });

      let images = [];

      let imageFormats = ["png", "jpg", "jpeg", "bmp", "gif"];

      let media = [];

      let parsed = anchorme(sanitized, {
        attributes: [
          {
            name: "target",
            value: "_blank"
          }
        ],
        exclude: URLObj => {
          for (let format of imageFormats) {
            if (URLObj.raw.endsWith(`.${format}`)) {
              if (images.findIndex(element => element == URLObj.raw) == -1) {
                images.push(URLObj.raw);
              }
              // returning "truthy" value will cause
              // exclusion of the URL
              return true;
            }
          }

          let id = getYouTubeID(URLObj.raw, { fuzzy: false });

          if (id != null) {
            if (media.findIndex(element => element == id) == -1) {
              media.push({
                type: "youtube",
                raw: URLObj.raw,
                id: id
              });
            }

            return true;
          }
        }
      });

      for (let image of images) {
        parsed = parsed.replace(
          new RegExp(image, "g"),
          `<a class="preview image" href="${image}" target="_blank">` +
            `<img src="${image}" alt="${image}">` +
            `</a>`
        );
      }

      for (let item of media) {
        switch (item.type) {
          case "youtube": {
            parsed = parsed.replace(
              item.raw,
              `<figure class="preview video">` +
                `<iframe width="640" height="360" src="https://www.youtube.com/embed/${item.id}" frameborder="0" allowfullscreen></iframe>` +
                `</figure>`
            );
            break;
          }
        }
      }

      return parsed;
    },
    isAuthored() {
      if (this.author) {
        return _.get(this.value, "user.id") == this.author.id;
      }
      return false;
    }
  },
  mounted() {
    setInterval(this.refreshPostedAt, 30000);
    this.refreshPostedAt();
  },
  methods: {
    onAttachmentsChange(attachments) {
      if (
        (this.value.content == null || this.value.content.length == 0) &&
        attachments.length == 0
      ) {
        this.remove();
      }
    },
    refreshPostedAt() {
      let difference = Math.abs(
        this.$moment().diff(this.$moment(this.value.posted_at), "seconds")
      );

      let fromNow = this.$moment(this.value.posted_at).fromNow();

      this.postedAt =
        (this.isMultiple ? "Обновлено" : "Добавлено") +
        " " +
        (difference < 10 ? "только что" : fromNow);
    },
    remove() {
      //   if (!this.isRemoving) {
      //     this.isRemoving = true;
      //     setTimeout(() => {
      //       this.isRemoving = false;
      //     }, 5000);
      //   } else {
      axios.delete(`/api/comments/${this.value.id}`).then(() => {
        this.$emit("remove", this.value);
      });
      //   }
    },
    ban() {
      axios
        .post(`/api/users/${this.value.user.id}/comments/ban`)
        .then(({ data: user }) => {
          this.toast("success", "Пользователь заблокирован");
          this.$emit("banned", user);
        })
        .catch(() => {
          this.toast("error", "@unexpected", error);
        });
    },
    unban() {
      axios
        .post(`/api/users/${this.value.user.id}/comments/unban`)
        .then(({ data: user }) => {
          this.toast("success", "Пользователь разблокирован");
          this.$emit("unbanned", user);
        })
        .catch(() => {
          this.toast("error", "@unexpected", error);
        });
    }
  }
});
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/comments/Comment.vue